// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__uJBa8","bannerLayer":"Banner_bannerLayer__Ls4qt"};